import {
  Component,
  Input,
  OnInit,
  HostListener
} from '@angular/core';
import {
  ActivatedRoute,
  Router,
} from '@angular/router';

import {
  Camera,
  CameraResultType,
  CameraSource,
} from '@capacitor/camera';
import {
  ActionSheetController,
  LoadingController,
  ModalController,
  Platform,
} from '@ionic/angular';

import { DataService } from '../../services/data.service';
import { AlertController } from '@ionic/angular';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
// const { FileSelector } = Plugins 
// import 'capacitor-file-selector'
@Component({
  selector: 'app-add-image',
  templateUrl: './add-image.page.html',
  styleUrls: ['./add-image.page.scss'],
})


export class AddImagePage implements OnInit {
  upload_images: any = [];
  attr_upload_images: any = [];
  image_list:any =[];
  product_img:any=[]; 
  product;
  @Input() product_id;
  @Input() edit_index;
  @Input() img_type;
  @Input() product_info;


  constructor(private activeRoute: ActivatedRoute, private router: Router,private platform: Platform,private actionSheetCtrl: ActionSheetController,public DBservice: DataService,public loadingCtrl: LoadingController,public modalCtrl:ModalController,public alertCtrl:AlertController) { 
    this.activeRoute.queryParams.subscribe((params:any) => {

      // let navParams = this.router.getCurrentNavigation().extras.state;
      // if(navParams){  
        // console.log(navParams)
        // this.order_id = navParams.order_id;
        // this.order_info = navParams;
      // }
      console.log(this.edit_index)
      console.log(this.product_info)
      // else if (params && params.id) {
        this.product_id = params.id;
        // this.get_product_detail(params.id);
        // this.get_order_detail(params.id);
      // }
    });
  }



  ngOnInit() {
    // console.log(this.product_info);

    const modalState = {
      modal : true,
      desc : 'fake state for our modal'
    };
    history.pushState(modalState, '');

  }

  @HostListener('window:popstate', ['$event'])
  dismissModal() {
    this.modalCtrl.dismiss();
  }


  get_product_detail(id){
     var data = {  Product: id  }
    this.DBservice.get_product(data).subscribe(data => {
        // console.log(data.message)
        this.product = data.message;
        this.image_list = this.product.images;
        // console.log(this.upload_images)
      }, error => {
        console.log(JSON.stringify(error.json()));
      });
   }


   view_img(){

   }


   insert_image_attribute(data){
    // console.log(this.edit_index)
    // console.log(this.product_info.variant_combination)
     var products:any= [];
     var response;
    //  console.log(this.product_info)
     let thatthis = this
    //   setTimeout(() => { }, 50);
      data.forEach(function (value,index) {
        products.push(
          {
            "parentfield": "image_list",
            "filename": value.name,
            "doctype": "Product Variant Combination",
            "docname": thatthis.product_info.variant_combination[thatthis.edit_index].parent,
            "filedata": '',
            "image_upload": true
          }
        )
        var reader:FileReader = new FileReader();
        // var reader = new FileReader();
        reader.readAsDataURL(value.data);
        reader.onloadend = (e) => {
            response = reader.result
            products[index].filedata = response
          }
        });
         // console.log(products)
         this.attr_upload_images = products;

         
       if(this.attr_upload_images.length != 0){
          if(this.product_info && this.product_info.variant_combination[this.edit_index].image_list && this.product_info.variant_combination[this.edit_index].image_list.length != 0){
            this.product_info.variant_combination[this.edit_index].image_list = [...this.product_info.variant_combination[this.edit_index].image_list,...this.attr_upload_images];
          }else{
            this.product_info.variant_combination[this.edit_index].image_list = this.attr_upload_images
          } 
        }
       this.modalCtrl.dismiss('success')
   }

   
   insert_images(data){
     var products:any= [];
     var response;
    //  console.log(this.product_info)
     let thatthis = this
    //   setTimeout(() => { }, 50);
      data.forEach(function (value,index) {
        products.push(
          {
            "parentfield": "product_images",
            "filename": value.name,
            "doctype": "Product",
            "docname": thatthis.product_id,
            "filedata": '',
            "image_upload": true
          }
        )
        var reader:FileReader = new FileReader();
        reader.readAsDataURL(value.data);
        reader.onloadend = (e) => {
            response = reader.result
            products[index].filedata = response
          }
        });

        this.upload_images = products;


        if(this.upload_images.length != 0){

          if(this.product_info && this.product_info.product_images && this.product_info.product_images.length != 0){
            this.product_info.product_images = [...this.product_info.product_images,...this.upload_images];
          }else{
            this.product_info.product_images = this.upload_images
            // this.product_img = this.upload_images  //john
            // console.log(this.product_img)
            // this.product_info.product_images = this.product_img;
            // if(this.DBservice.product_info && this.DBservice.product_info.upload_images && this.DBservice.product_info.upload_images.length == 0){
            //   this.DBservice.product_info.upload_images = this.upload_images
            // }else{
            //   this.DBservice.product_info.upload_images = [...this.DBservice.product_info.upload_images,...this.upload_images];
            // }
          } 

          // if(this.product_info && this.DBservice.image_page == 'variants'){
          //   this.upload_images.map((val:any)=>{
          //     console.log(val,'upload img..')
          //   })
          //   this.product_info.variant_combination.map((res:any) => {
          //     res.image_list == null ? res.image_list = this.upload_images : [...this.upload_images]
          //     // this.upload_images.map((val:any)=>{
          //     //   res.image = 
          //     // })
          //     console.log(res.image_list,'image_list')
          //   })
          // }
         
        }
       

        this.modalCtrl.dismiss('success')
        // this.upload_image();
        // console.log(this.DBservice.product_info)
   }

   reorderList(e){
    //  console.log(e)
     let movedItem = this.product_info.product_images.splice(e.detail.from,1)[0];
     this.product_info.product_images.splice(e.detail.to, 0, movedItem)
     e.detail.complete();
   }



   async takePicture() {
    let myImage;
    const image = await Camera.getPhoto({
      quality: 90,
      allowEditing: true,
      resultType: CameraResultType.Uri, // Uri , Base64, DataUrl
      source: CameraSource.Camera
    });

    myImage = image.webPath;
    console.log(myImage)
  }
   

  async selectImageSource() {
    const buttons = [
      {
        text: 'Take Photo',
        icon: 'camera',
        handler: () => {
          this.takePicture();
          // this.addImage(CameraSource.Camera);
        }
      },
      {
        text: 'Choose From Photos Photo',
        icon: 'image',
        handler: () => {
          // this.select();
          
          // this.addImage(CameraSource.Photos);
        }
      }
    ];
 
    // Only allow file selection inside a browser
    // if (!this.platform.is('hybrid')) {
    //   buttons.push({
    //     text: 'Choose a File',
    //     icon: 'attach',
    //     handler: () => {
    //       this.fileInput.nativeElement.click();
    //     }
    //   });
    // }
 
    const actionSheet = await this.actionSheetCtrl.create({
      header: 'Select Image Source',
      buttons
    });
    await actionSheet.present();
  }


  async upload_image() {
    let loader = await this.loadingCtrl.create({
      spinner: 'bubbles',
      message: 'Loading Please Wait...'
    });

    // this.upload_images.map(async (res,index) =>{
        await loader.present();
        // {
        //   "parentfield": "product_images",
        //   "filename": value.name,
        //   "doctype": "Product",
        //   "docname": thatthis.product_id,
        //   "filedata": ''
        // }
        // for eg : data : {"products":["image_name":"ff.png","filedata":binary64]}
        this.DBservice.uploadfiles( { "products" :  this.upload_images }).then(data => {
          console.log(data)
          if(data.message.status == 'success'){
            this.modalCtrl.dismiss('success')
          }
        },err => {
          console.error(err);
          setTimeout(() => {  loader.dismiss();  }, 50);
        })
    // })

    // for (var i = 0; i < this.upload_images.length; i++) {
    //   if (!this.upload_images[i].name) {
    //     await loader.present();
    //     var imagedata = {
    //       "products": [
    //         {
              
    //           // "fieldname":"category_image",
    //           // "filename": this.upload_images[i].image_name,
    //           "parentfield": "product_images",
    //           "filename": this.upload_images[i].file_name,
    //           "doctype": "Product",
    //           "docname": this.product_id,
    //           "filedata": this.upload_images[i].filedata
    //           // "filedata": this.upload_images[i].img
       
    //         }
    //       ]
    //     }
    //     this.DBservice.uploadfiles(imagedata).subscribe(data => {
    //         // if (data._error_message) {
    //         //   this.DBservice.alert(data._error_message)
    //         // }
    //         // this.edititem(this.products, this.activeitem)
    //         console.log(data)
    //         // this.viewCtrl.dismiss();
    //       }, err => {
    //         console.error(err);
    //         setTimeout(() => {  loader.dismiss();  }, 50);
    //       })
    //   }
    // }
    setTimeout(() => {  loader.dismiss(); }, 50);

  }

  async remove_img(index,image_info){
    const alert = await this.alertCtrl.create({
      // header: 'Alert!',
      // subHeader: 'Are you sure! Do you want to delete?',
      message: 'Are you sure do you want to delete?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        },
        {
          text: 'OK',
          role: 'confirm',
          handler: () => {
            this.remove_img_1(index,image_info);
            // this.handlerMessage = 'Alert confirmed';
          },
        },
      ],
    });

    await alert.present();

    const { role } = await alert.onDidDismiss();
  }

  async remove_img_1(index, image_info) {
    // console.log(image_info)
    if (image_info.name != undefined) {
      let loader = await this.loadingCtrl.create({
        spinner: 'bubbles',
        message: 'Loading Please Wait...'
      });
      await loader.present();
      var imagedata = { childname: image_info.name, doctype: 'Product' }
      // var imagedata = { childname: image_info.name, doctype: 'Product Update Approval' }
      this.DBservice.remove_image(imagedata).subscribe((data) => {
          setTimeout(() => {  loader.dismiss();  }, 200);
          // console.log(data);
          this.product_info.product_images.splice(index, 1)
        }, error => {
          setTimeout(() => {  loader.dismiss();  }, 50);
          console.log(JSON.stringify(error.json()));
        });
    }else{
      this.product_info.product_images.splice(index, 1)
    }
  }

  async delete_img(index,image_info){
    const alert = await this.alertCtrl.create({
      // header: 'Alert!',
      // subHeader: 'Are you sure! Do you want to delete?',
      message: 'Are you sure do you want to delete?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        },
        {
          text: 'OK',
          role: 'confirm',
          handler: () => {
            this.remove_attr_img(index,image_info);
            // this.handlerMessage = 'Alert confirmed';
          },
        },
      ],
    });

    await alert.present();

    const { role } = await alert.onDidDismiss();
  }

  async remove_attr_img(index,image_info){
      console.log(image_info)
     if (image_info.name != undefined) {
      let loader = await this.loadingCtrl.create({
        spinner: 'bubbles',
        message: 'Loading Please Wait...'
      });
      await loader.present();
      var imagedata = { file_id: image_info.name }
      this.DBservice.remove_combination_img(imagedata).subscribe((data) => {
          setTimeout(() => {  loader.dismiss();  }, 200);
          console.log(data);
          let arr =  this.product_info.variant_combination[this.edit_index].image_list
          arr.splice(index, 1)
        }, error => {
          setTimeout(() => {  loader.dismiss();  }, 50);
          console.log(JSON.stringify(error.json()));
        });
    }else{
      this.product_info.variant_combination[this.edit_index].image_list.splice(index, 1)
    }
  }


  remove_other(data){
    this.product_info.product_images.map(res =>{
        if(res.product_image != data){
          res.is_primary = 0
        } else {
          res.is_primary ?  res.is_primary = 1 : res.is_primary = 0
        }
    })
  }

  remove_attribute(img){
    // console.log(img,'attr')
  }

  

  // async select()
  // {
  //   let multiple_selection = true
  //   //let ext = [".jpg",".png",".pdf",".jpeg"] // list of extensions
  //   let ext = ["MP3", "ImaGes"] // combination of extensions or category 
  //   //let ext = ["videos", "audios", "images"] // list of all category
  //   //let ext = ["*"] // Allow any file type
  //   ext = ext.map(v => v.toLowerCase());
  //   let formData = new FormData();
  //   let selectedFile = await FileSelector.fileSelector({
  //     multiple_selection: multiple_selection,
  //     ext: ext
  //   })

  //   if(this.platform.is("android"))
  //   {
  //     let paths = JSON.parse(selectedFile.paths)
  //     let original_names = JSON.parse(selectedFile.original_names)
  //     let extensions = JSON.parse(selectedFile.extensions)
  //     for (let index = 0; index < paths.length; index++) {
  //         const file = await fetch(paths[index]).then((r) => r.blob());
  //         formData.append(
  //           "myfile[]",
  //           file,
  //           original_names[index] + extensions[index]
  //         );
  //       }
  //   }
  //   else if(this.platform.is("ios"))
  //   {
  //     for (let index = 0; index < selectedFile.paths.length; index++) {
  //       const file = await fetch(selectedFile.paths[index]).then((r) => r.blob());
  //       formData.append(
  //         "myfile[]",
  //         file,
  //         selectedFile.original_names[index] + selectedFile.extensions[index]
  //       );
  //     }
  //   }
  //   else
  //   {
  //     FileSelector.addListener("onFilesSelected", (data:FileList) => {
  //           for(var i = 0; i < data.length; i++)
  //           {
  //             console.log(data[i].name)
  //             formData.append(
  //               "myfile[]",data[i],data[i].name + data[i].type
  //               // data.item(i),
  //               // data.item(i).name + data.item(i).type 
  //             );
  //           }
  //           console.log(formData)
  //       }); 
  //   }
  // }

  drop(event: any,array) {
    console.log(event)
    moveItemInArray(array, event.previousIndex, event.currentIndex);
  }

  mark_primary(eve,index,obj,array){
    let checked = eve.detail.checked;
    if(eve.detail.checked){
      array.map((res,i)=>{
        if(i == index){
          obj.name ? this.update_primary_image(obj,checked) : obj.is_primary = 1;
        }else{
          res.is_primary = 0;
        }
      })
    }else{
      // obj.is_primary = 0;
      obj.name ? this.update_primary_image(obj,checked) : obj.is_primary = 0;
    }
  }

  update_primary_image(obj,checked){
    console.log(obj)
    let data = {
      "name": obj.name,
      "is_primary": checked ? 1 : 0,
      "parent": obj.parent,
      "parentfield": "product_images",
      "parenttype": "Product",
      "doctype": "Product Image"
    }

    this.DBservice.update_primary_image(data).subscribe(res=>{
       if(res && res.message && res.message.status == 'Success'){
         obj.is_primary = checked ? 1 : 0;
       }else{
        this.DBservice.alert('Something went wrong try again later')
       }
    },error=>{this.DBservice.alert('Something went wrong try again later')})
  }
}
